export const familyMemberOptions = [
  { label: "Mark", value: "Mark" },
  { label: "Julia", value: "Julia" },
  { label: "Noah", value: "Noah" },
  { label: "Sonja", value: "Sonja" },
  { label: "Henry", value: "Henry" },
];

export const timesOptions = () => {
  const ret = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      const hr = hour < 10 ? `0${hour}` : `${hour}`;
      const min = minute < 10 ? `0${minute}` : `${minute}`;
      const onClock = {
        value: `${hr}:${min}`,
        label: `${hr}:${min}`,
      };
      ret.push(onClock);
    }
  }
  return ret;
};

export function generateDateIntervals(interval, startDate, endDate) {
  if (interval === "none" || interval === undefined)
    return [formatDate(startDate)];

  const result = [];
  const start = new Date(startDate);
  const end = new Date(endDate);
  const current = new Date(start);

  while (current <= end) {
    result.push(formatDate(current));

    switch (interval) {
      case "weekly":
        current.setDate(current.getDate() + 7);
        break;
      case "monthly":
        current.setMonth(current.getMonth() + 1);
        break;
      case "yearly":
        current.setFullYear(current.getFullYear() + 1);
        break;
      default:
        throw new Error(
          "Ungültiges Intervall. Erlaubt sind: weekly, monthly, yearly."
        );
    }
  }

  return result;
}

// Hilfsfunktion zum Formatieren als "YYYY-MM-DD"
function formatDate(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
